import React from "react";
import StreamResult from "../StreamResult";

const MixerPage = ({ transInput, transInputs, multiResults, selectResultPage }: any) => {
  return (
    <StreamResult
      multiResults={multiResults}    // 多任务对比数据（核心）
      materials={transInput}         // 物料信息（第一个任务，侧边栏用）
      transInputs={transInputs}      // 每个任务对应的 input 数据
      selectResultPage={selectResultPage}
    />
  );
};

export default MixerPage;